export default "__VITE_ASSET__Cqly2M2w__"